module.exports = __webpack_public_path__ + "static/investments-399c6c8051c606895f1f7894c6dc5194.mp4";